<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-percent`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_d60ef09237__clip0_271_29180)"><path d="M8 0.109375C12.3587 0.109551 15.8924 3.64327 15.8926 8.00195C15.8924 12.3606 12.3587 15.8944 8 15.8945C3.64131 15.8944 0.107598 12.3606 0.107422 8.00195C0.107568 3.64325 3.64129 0.109521 8 0.109375ZM8 1.44336C4.37767 1.44351 1.44155 4.37963 1.44141 8.00195C1.44158 11.6243 4.37769 14.5614 8 14.5615C11.6223 14.5613 14.5594 11.6242 14.5596 8.00195C14.5594 4.37965 11.6223 1.44354 8 1.44336ZM10.7422 4.3125C11.0025 4.05226 11.4242 4.05226 11.6846 4.3125C11.9449 4.57285 11.9449 4.99551 11.6846 5.25586L5.25586 11.6846C4.99551 11.9449 4.57285 11.9449 4.3125 11.6846C4.05225 11.4242 4.05222 11.0025 4.3125 10.7422L10.7422 4.3125ZM9.30371 9.30176C9.8243 8.78163 10.6679 8.78163 11.1885 9.30176C11.7092 9.82246 11.7092 10.6668 11.1885 11.1875C10.6678 11.7081 9.82439 11.7081 9.30371 11.1875C8.78301 10.6668 8.78301 9.82246 9.30371 9.30176ZM4.81152 4.80957C5.33211 4.28944 6.1757 4.28944 6.69629 4.80957C7.21699 5.33027 7.21699 6.17461 6.69629 6.69531C6.17561 7.21593 5.33221 7.21593 4.81152 6.69531C4.29082 6.17461 4.29082 5.33027 4.81152 4.80957Z"/></g><defs><clipPath id="svg_d60ef09237__clip0_271_29180"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLinePercent',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
